@if (!isMobile) {
    <div class="flex-line">
        <div class='search-input-container' rtlDiv>
            <div class="search-frame">
                <img class='search-input-img' src="assets/images/sidemenu/table_search_icon.png" alt="" />
                <input class='search-input' type="text" (input)="applyFilter($event.target)" placeholder="{{
                            'OTHER.SEARCH' | translate }}" name="">
            </div>
        </div>
        <div class="options-container" rtlDiv>
            <div class='export-btn-wrapper' (click)="exportToCsv()" rtlDiv>
                <img class='export-img' src="assets/images/global/excel.svg" alt="" />
                <div class='export-title' rtlDiv>{{ 'OTHER.EXCEL' | translate }}</div>
            </div>
            @if(isAllRemoved() && selection.selected.length > 1){
                <div class="add-btn" (click)="undoBulkDelete()">
                    <img src="assets/images/reports/undo.svg" alt="undo" rtlDiv />
                    <div class="opt-btn-txt">{{'TITLES.UNDO_DELETING' | translate }} ({{selection.selected.length}})</div>
                </div>
            }
            @if(isAllNotRemoved() && selection.selected.length > 1){
                <div class="add-btn" (click)="deleteBulkItems()">
                    <img src="assets/images/reports/bin.svg" alt="delete" rtlDiv />
                    <div class="opt-btn-txt">{{'TITLES.DELETE' | translate }} ({{selection.selected.length}})</div>
                </div>
            }
            @if(isAllSuspected() && selection.selected.length > 1){
                <div class="add-btn" (click)="acceptBulkItems()">
                    <img src="assets/images/reports/included.svg" alt="accept" rtlDiv />
                    <div class="opt-btn-txt">{{'COLLECTION_REPORT.ACCEPT' | translate }} ({{selection.selected.length}})</div>
                </div>
            }
            <!-- <div class="add-btn" (click)="openAddCollectionModal()">
                <img src="assets/images/reports/plus.svg" alt="plus" rtlDiv />
                <div class="add-btn-txt">{{ 'COLLECTION_REPORT.NEW_COLLECTION' | translate }}</div>
            </div> -->
        </div>
    </div>

    <div class="filter-tags-container" rtlDiv>
        <div [ngClass]="{'filter-tag': registeredCollectionLength > 0,'empty-filter-tag':registeredCollectionLength == 0,'selected-filter-tag':registeredCollection,'not-selected-filter-tag':!registeredCollection}"
            (click)="applyState('registered')">
            <div>{{ 'COLLECTION_REPORT.REGISTERED_COLLECTION' | translate }}</div>
            <div>({{registeredCollectionLength}})</div>
        </div>
        <div [ngClass]="{'filter-tag': suspiciousCollectionLength > 0,'empty-filter-tag':suspiciousCollectionLength == 0,'selected-filter-tag':suspiciousCollection,'not-selected-filter-tag':!suspiciousCollection}"
            (click)="applyState('suspicious')">
            <div>{{ 'COLLECTION_REPORT.SUSPICIOUS_COLLECTION' | translate }}</div>
            <div>({{suspiciousCollectionLength}})</div>
        </div>
        <div [ngClass]="{'filter-tag': invalidCollectionLength > 0,'empty-filter-tag':invalidCollectionLength == 0,'selected-filter-tag':invalidCollection,'not-selected-filter-tag':!invalidCollection}"
            (click)="applyState('invalid')">
            <div>{{ 'COLLECTION_REPORT.INVALID_COLLECTION' | translate }}</div>
            <div>({{invalidCollectionLength}})</div>
        </div>
        <div [ngClass]="{'filter-tag': removedCollectionLength > 0,'empty-filter-tag':removedCollectionLength == 0,'selected-filter-tag':removedCollection,'not-selected-filter-tag':!removedCollection}"
            (click)="applyState('removed')">
            <div>{{ 'COLLECTION_REPORT.REMOVED_COLLECTION' | translate }}</div>
            <div>({{removedCollectionLength}})</div>
        </div>
    </div>

    <table class="table" mat-table #table [dataSource]="dataSource" matSort matSortStart="asc" matSortActive="bin_name"
        matSortDisableClear (matSortChange)="sortData($event)" matSortDirection="desc" rtlDiv>
        <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
              <mat-checkbox (change)="$event ? masterToggle() : null"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()">
              </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row" class="list-checkbox chb-space" rtlDiv>
              <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                [checked]="selection.isSelected(row)">
              </mat-checkbox>
            </td>
        </ng-container>
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="bin_name" class="th-title">
                {{ 'SITE_MANAGMENT.BIN_NAME' | translate }} </th>
            <td [ngClass]="{'cursor-auto' : user_role_id == 8}" mat-cell *matCellDef="let element"
                class="td-value">
                <div class="flex-th-value">
                    @if(user_role_id != 8){
                        <span [ngClass]="{'cut-txt' : element && element.bin_name.length > 11}" (click)="openElementBinInfo(element)" title="{{element ? element.bin_name : ''}}">{{element ? element.bin_name : ''}}</span>
                    }@else{
                        <span title="{{element ? element.bin_name : ''}}" class="cut-txt binNameHref">{{element ? element.bin_name : ''}}</span>
                    }
                    @if (element.number_of_bins_in_cluster > 1 && element.chosenCluster) {
                        <button (click)="changeSubmitClickedStatus(element)" class="tooltip-btn" type="button">
                            <img src="assets/images/binInfoPage/clusterIndication.svg" alt="" />                        
                        </button>
                    }
                </div>
            </td>
        </ng-container>
        <ng-container matColumnDef="evType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="is_suspected_collection" class="th-title space">
                {{ 'TICKET_MANAGEMENT.EVENT_TYPE' | translate }} </th>
            <td mat-cell *matCellDef="let element" class="td-value space">
                @if(element.is_suspected_collection == 0){
                    <span class="registered_collection">{{ 'COLLECTION_REPORT.REGISTERED_COLLECTION_SINGULAR' | translate }}</span>
                }@else if(element.is_suspected_collection == 1){
                    <span class="suspicious_collection">{{ 'COLLECTION_REPORT.SUSPICIOUS_COLLECTION_SINGULAR' | translate }}</span>
                }@else if(element.is_suspected_collection == null && element.is_suspected_as_collection_event == null){
                    <span class="deleted_collection">{{ 'COLLECTION_REPORT.DELETED_COLLECTION_SINGULAR' | translate }}</span>
                }@else if(element.is_approved_suspected_as_collection_event == false && element.is_deleted_suspected_as_collection_event != true){
                    <span class="invalid_collection">{{ 'COLLECTION_REPORT.INVALID_COLLECTION_SINGULAR' | translate }}</span>
                }
            </td>
        </ng-container>
        <ng-container matColumnDef="siteName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="site_name"
                class="th-title space">
                {{ 'TRUCK_MAP.SITE' | translate }} </th>
            <td mat-cell *matCellDef="let element" class="td-value space">
                <div class="dflex" rtlDiv> 
                    <span>{{element ? element.site_name : ''}}</span>
                    <span>({{element ? getSiteCollectionCount(element.site_id,element.bin_collection_time) : 0}})</span>
                </div>
            </td>
        </ng-container>
        <ng-container matColumnDef="address">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="bin_address" class="th-title space">
                {{ 'LIST_COLUMNS.ADDRESS' | translate }} </th>
            <td mat-cell *matCellDef="let element" class="td-value space">
                <span title="{{element ? element.bin_address : ''}}" class="cut-txt"> {{element ? element.bin_address :
                    ''}}</span>
            </td>
        </ng-container>
        <ng-container matColumnDef="clearing">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="bin_collection_time" class="th-title space"> {{
                'LIVE_INFO.LIST_COLLECTION_TIME' | translate }} </th>
            <td mat-cell *matCellDef="let element" class="td-value space">
                {{currentLang == 'iw' && element ? element.bin_collection_time_he : element.bin_collection_time}}
            </td>
        </ng-container>
        <ng-container matColumnDef="arrival_time">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="collected_driver_arrival_time" class="th-title space"> {{
                'COLLECTION_REPORT.ARRIVAL_TIME' | translate }} </th>
            <td mat-cell *matCellDef="let element" class="td-value space">
                {{currentLang == 'iw' && element ? element.collected_driver_arrival_time_he : element.collected_driver_arrival_time}}
            </td>
        </ng-container>
        <ng-container matColumnDef="cause">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="collection_cause_name" class="th-title space">
                {{ 'TITLES.COLLECTION_CAUSE' | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="td-value space">
                @if (currentLang != 'iw') {
                    <span>{{element ? element.collection_cause_name: ''}}</span>
                }
                @if (currentLang == 'iw') {
                    <span>{{element ? element.collection_cause_name_hebrew: ''}}</span>
                }
            </td>
        </ng-container>
        <ng-container matColumnDef="removed_reason">
            <th [hidden]="!isRemovedCollectionEnabled()" mat-header-cell *matHeaderCellDef mat-sort-header="removed_reason" class="th-title space"> 
                {{'TICKET_MANAGEMENT.REMOVED_REASON' | translate }} 
            </th>
            <td [hidden]="!isRemovedCollectionEnabled()" mat-cell *matCellDef="let element" class="td-value space">
                @if (currentLang != 'iw') {
                    <span>{{element ? element.suspected_reason_name: ''}}</span>
                }
                @if (currentLang == 'iw') {
                    <span>{{element ? element.suspected_reason_name_hebrew: ''}}</span>
                }
            </td>
        </ng-container>
        <ng-container matColumnDef="removed_by">
            <th [hidden]="!isRemovedCollectionEnabled()" mat-header-cell *matHeaderCellDef mat-sort-header="removed_by_name" class="th-title space"> 
                {{'TICKET_MANAGEMENT.REMOVED_BY' | translate }} 
            </th>
            <td [hidden]="!isRemovedCollectionEnabled()" mat-cell *matCellDef="let element" class="td-value space">
                {{element ? element.removed_by_name : ''}}
            </td>
        </ng-container>
        <ng-container matColumnDef="removed_date">
            <th [hidden]="!isRemovedCollectionEnabled()" mat-header-cell *matHeaderCellDef mat-sort-header="approval_date" class="th-title space"> 
                {{'TICKET_MANAGEMENT.REMOVED_DATE' | translate }} 
            </th>
            <td [hidden]="!isRemovedCollectionEnabled()" mat-cell *matCellDef="let element" class="td-value space">
                {{currentLang == 'iw' && element ? element.removed_date_he : element?.removed_date}}
            </td>
        </ng-container>
        <ng-container matColumnDef="suspicion_reason">
            <th [hidden]="!isSuspiciousCollectionEnabled()" mat-header-cell *matHeaderCellDef mat-sort-header="suspicion_reason" class="th-title space"> 
                {{'TITLES.SUSPICION_REASON' | translate }} 
            </th>
            <td [hidden]="!isSuspiciousCollectionEnabled()" mat-cell *matCellDef="let element" class="td-value space">
                @if (currentLang != 'iw') {
                    <span>{{element ? element.suspected_reason_name_for_suspicious_collection: ''}}</span>
                }
                @if (currentLang == 'iw') {
                    <span>{{element ? element.suspected_reason_name_for_suspicious_collection_hebrew: ''}}</span>
                }
            </td>
        </ng-container>
        <ng-container matColumnDef="capacity_before">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="bin_fill_level_before_collection" class="th-title space">
                {{ 'COLLECTION_REPORT.PRE_PICKUP' | translate }} </th>
            <td mat-cell *matCellDef="let element" class="td-value space">
                <div class="progress-flex">
                    <div class="table-status-progress-bar-wrapper progress">
                        <div class="table-status-progress-line progress-bar"
                            [ngStyle]="getProgressBarStyleInternalCollections(element,element.bin_fill_level_before_collection)"></div>
                    </div>
                    <div class='table-status-progress-bar-title' rtlDiv>{{element ?
                        element.bin_fill_level_before_collection: ''}}{{capacityDisplaySymbol}}
                    </div>
                </div>
            </td>
        </ng-container>
        <ng-container matColumnDef="capacity_after">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="bin_fill_level_after_collection" class="th-title space">
                {{ 'COLLECTION_REPORT.POST_PICKUP' | translate }} </th>
            <td mat-cell *matCellDef="let element" class="td-value space">
                <div class="progress-flex">
                    <div class="table-status-progress-bar-wrapper progress">
                        <div class="table-status-progress-line progress-bar"
                            [ngStyle]="getProgressBarStyleInternalCollections(element,element.bin_fill_level_after_collection)"></div>
                    </div>
                    <div class='table-status-progress-bar-title' rtlDiv>{{element ?
                        element.bin_fill_level_after_collection: ''}}{{capacityDisplaySymbol}}
                    </div>
                </div>
            </td>
        </ng-container>
        <ng-container matColumnDef="collection_mode">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="collection_mode" class="space th-title"> {{ 'MANAGE_BIN.INCLUDE_IN_WORKPLAN' | translate }} </th>
            <td mat-cell *matCellDef="let element" class="space td-value">
                <div class="stretch-img">
                    <img class="img-wp" src="{{element ? getImg(element.is_part_of_work_plan) : ''}}" alt="" />                
                </div>
            </td>
          </ng-container>
        <ng-container matColumnDef="manage">
            <th mat-header-cell *matHeaderCellDef disabled="true" mat-sort-header="manage"></th>
            <td mat-cell *matCellDef="let element">
                <div class="manage-bin-button hide-manage-bin" rtlDiv>
                    @if((element.is_suspected_collection == 0 || element.is_suspected_collection == 1 || element.is_approved_suspected_as_collection_event == false) && element.is_deleted_suspected_as_collection_event != true){
                        <div class="manage-opt-red" (click)="deleteItem(element)">{{'TITLES.DELETE' | translate }}</div>      
                    }
                    @if(element.is_suspected_collection == 0){
                        <!-- <div class="manage-opt" (click)="duplicateItem(element)">{{'COLLECTION_REPORT.DUPLICATE' | translate }}</div> -->
                    }@else if((element.is_suspected_collection == 1 || element.is_approved_suspected_as_collection_event == false) && element.is_deleted_suspected_as_collection_event != true){
                        <div class="manage-opt" (click)="acceptItem(element)">{{'COLLECTION_REPORT.ACCEPT' | translate }}</div>                                        
                    }      
                    @if(isRemovedCollection(element)){
                        <div class="manage-opt" (click)="undoDeleteItem(element)">{{'TITLES.UNDO_DELETING' | translate }}</div>
                    }
                </div>              
            </td>
          </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr class="bins-row" mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
    <div [hidden]="filteredData.length == 0">
        <app-pagination [chosenBins]="filteredData" (pageChange)='onPageChange($event)' [filesPerPage]="10"></app-pagination>
    </div>
    @if(filteredData.length == 0){
        <div class="empty-state-container">
            <img src="assets/images/reports/empty_state.svg" alt="" />                        
            <div class="empty-state-text">
                {{ 'COLLECTION_REPORT.NO_COLLECTIONS' | translate }}
            </div>
        </div>
    }
}

@if (isMobile) {}